import React, { useState, useEffect } from "react";
import { cookieHelpers } from "helpers/cookieHelpers";

export default function SessionTimer() {
   const [timeRemaining, setTimeRemaining] = useState(null);

   useEffect(() => {
      const updateTimer = () => {
         const expiryDate = cookieHelpers.getSessionExpiryCookie();
         if (!expiryDate) {
            setTimeRemaining(null);
            return;
         }

         const remaining = expiryDate.getTime() - Date.now();
         if (remaining <= 0) {
            setTimeRemaining(0);
         } else {
            setTimeRemaining(remaining);
         }
      };

      updateTimer();
      const interval = setInterval(updateTimer, 1000);

      return () => clearInterval(interval);
   }, []);

   if (timeRemaining === null) {
      return null;
   }

   const minutes = Math.floor(timeRemaining / 60000);
   const seconds = Math.floor((timeRemaining % 60000) / 1000);
   const isLessThanOneMinute = timeRemaining < 60000;

   return (
      <div className={`session-timer ${isLessThanOneMinute ? "session-timer-warning" : ""}`}>
         <span className="timer-label">Timp rămas: </span>
         <span className="timer-value">
            {String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
         </span>
      </div>
   );
}